import { createEmptyFetchable, createFetchableReducer } from 'helpers/loadableHelpers'
import { Reducer } from 'interfaces'
import { CreateCCPaymentMethodAction, ResetCreateCCPaymentMethodAction } from 'components/features/creditCard/creditCardStore/actions'
import { CreditCardAppState } from 'components/features/creditCard/creditCardStore/state'
import { KILL_ALL_FLOATING_PANES, KILL_FLOATING_PANES, MODIFY_FLOATING_PANE } from 'actions/floatingPanesActions'

const reducer = createFetchableReducer<null>()
const INITIAL_STATE = createEmptyFetchable<null>()
export const createPaymentMethodRequestReducer: Reducer<CreditCardAppState['createPaymentMethodRequest']> = (prevState = INITIAL_STATE, action) => {
  switch (action.type) {
    case CreateCCPaymentMethodAction.type: {
      return reducer(prevState, action)
    }

    case ResetCreateCCPaymentMethodAction.type:
    case KILL_ALL_FLOATING_PANES:
    case KILL_FLOATING_PANES:
    case MODIFY_FLOATING_PANE: {

      const { errorsMap, ...prevCleanState } = prevState
      return {
        ...prevCleanState,
        errorCode: null,
      }
    }
  }

  return prevState
}
